import React, { memo, useCallback } from 'react';
import { makeStyles } from '@mui/styles';

import { Text, View } from '../Base';
import palette from '../styles/palette';
import FilterItemButton from './FilterItemButton';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    color: palette.yellow,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '1.125rem',
    paddingBottom: '0.5rem',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
}));

const FilterSection = ({
  values,
  selectedValues = [],
  title,
  field,
  onChange,
}) => {
  const styles = useStyles();

  const handleOnClick = useCallback(
    (value, label) => {
      if (!selectedValues.length && !value) {
        return;
      }

      if (!value) {
        return onChange(field, label, []);
      }

      let result;
      if (selectedValues.includes(value)) {
        result = selectedValues.filter((v) => v !== value);
      } else {
        result = [...selectedValues, value];
      }
      onChange(field, label, result);
    },
    [field, selectedValues, onChange]
  );

  return (
    <View className={styles.section}>
      <Text className={styles.title}>{title}</Text>
      <View className={styles.content}>
        {values.map(({ label, value }) => (
          <FilterItemButton
            key={label + value}
            onClick={() => handleOnClick(value, label)}
            active={
              selectedValues.includes(value) ||
              (!selectedValues.length && !value)
            }
          >
            {label}
          </FilterItemButton>
        ))}
      </View>
    </View>
  );
};

export default memo(FilterSection);
